import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
//import { GroupsComponent } from './Components/groups/groups.component';
import { NewPollComponent } from './Components/new-poll/new-poll.component';
import { VoteResultComponent } from './Components/vote-result/vote-result.component';
import { UserManagementComponent } from './Components/user-management/user-management.component';
// import { CreteBmDialogComponent } from './Components/crete-bm-dialog/crete-bm-dialog.component';
import { CreateBmDialogComponent } from './Components/create-bm-dialog/create-bm-dialog.component';
//import { BordMembersComponent } from './Components/bord-members/bord-members.component';
// import {MatSidenavModule} from '@angular/material/sidenav';
import { MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {MatChipsModule} from '@angular/material/chips';
import { CreateUpdateGroupComponent } from './Components/create-update-group/create-update-group.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import { CompanyComponent } from './Components/company/company.component';
import { CreateCompanyDialogComponent } from './Components/create-company-dialog/create-company-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import {MatStepperModule} from '@angular/material/stepper';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
// import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatRadioModule} from '@angular/material/radio';
import {MatGridListModule} from '@angular/material/grid-list';

import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { ShowPollResultComponent } from './Components/show-poll-result/show-poll-result.component';
import { HeaderComponent } from './Components/header/header.component';
import { CreateUserComponent } from './Components/create-user/create-user.component';
import { HomePageComponent } from './Components/home-page/home-page.component';
import { BordMembersComponent } from './Components/bord-members/bord-members.component';
import { GroupsComponent } from './Components/groups/groups.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { AddNumberDialogComponent } from './Components/add-number-dialog/add-number-dialog.component';
import { PollsComponent } from './Components/polls/polls.component';
import { ExecuteComponent } from './Components/execute/execute.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { EditBmComponent } from './Components/edit-bm/edit-bm.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { ConformationComponent } from './Components/conformation/conformation.component';
import {MatTabsModule} from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EditPollComponent } from './Components/edit-poll/edit-poll.component';
import {  HighchartsChartModule } from 'highcharts-angular';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatMenuModule} from '@angular/material/menu';
import { SmsDetailsComponent } from './Components/sms-details/sms-details.component';
import { Angular2CsvModule } from 'angular2-csv';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { ManualUpdateDialogComponent } from './Components/manual-update-dialog/manual-update-dialog.component';
import { BulkUpdateComponent } from './Components/bulk-update/bulk-update.component';
import { CloneDialogComponent } from './Components/clone-dialog/clone-dialog.component';
import { RankedChoiceVotingDialogComponent } from './Components/ranked-choice-voting-dialog/ranked-choice-voting-dialog.component';
import { RankedChoiceVoteingSmsComponent } from './Components/ranked-choice-voteing-sms/ranked-choice-voteing-sms.component';
import { RankedChoiceResComponent } from './Components/ranked-choice-res/ranked-choice-res.component';
// import { Angular2csvComponent } from './Components/angular2csv/angular2csv.component';
// import { HighchartsChartComponent } from 'highcharts-angular';
// import { NgxMatDatetimePickerModule, NgxMatTimepickerModule,NgxMatNativeDateModule } from 'ngx-mat-datetime-picker';




@NgModule({
  declarations: [
    NewPollComponent,
    VoteResultComponent,
    UserManagementComponent,
    CreateBmDialogComponent,
    CreateUpdateGroupComponent, 
    CompanyComponent, 
    CreateCompanyDialogComponent, 
    ShowPollResultComponent, 
    HeaderComponent,
    CreateUserComponent,
    HomePageComponent,
    BordMembersComponent,
    GroupsComponent,
    AddNumberDialogComponent,
    PollsComponent,
    ExecuteComponent,
    EditBmComponent,
    ConformationComponent,
    EditPollComponent,
    SmsDetailsComponent,
    ManualUpdateDialogComponent,
    BulkUpdateComponent,
    CloneDialogComponent,
    RankedChoiceVotingDialogComponent,
    RankedChoiceVoteingSmsComponent,
    RankedChoiceResComponent,
    // Angular2csvComponent,
    // HighchartsChartComponent

    
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    MatDialogModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatChipsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatIconModule,
    MatGridListModule,
    MatSelectModule,
    // BrowserAnimationsModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatStepperModule,
    MatDatepickerModule,
    MatRadioModule,
    MatButtonToggleModule,
    // NgxMatTimepickerModule,
    // NgxMatNativeDateModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatProgressBarModule,
    Ng2SearchPipeModule,
    NgxMaterialTimepickerModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    HighchartsChartModule,
    MatExpansionModule,
    MatMenuModule,
    Angular2CsvModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatCardModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeModule { }
